<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="client && client.id">{{ 'CLIENTS.CLIENTS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!client || !client.id">{{ 'CLIENTS.CLIENTS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="client-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.TYPE' | translate }}</label>
          <app-type-select
            [parentFormGroup]="form"
            [groupType]="'clients'"
            [passFormControlName]="'type_id'"
          ></app-type-select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>

      <div class="col-sm-2">
        <app-countries-select [parentFormGroup]="form"></app-countries-select>
      </div>

      <div class="col-sm-2">
        <app-cities-select [parentFormGroup]="form"></app-cities-select>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.ADDRESS' | translate }}</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.VAT_NUMBER' | translate }}</label>
          <input type="text" class="form-control" formControlName="vat_number" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.LANGUAGES_SPOKEN' | translate }}</label>
          <app-locales-select [FormControl]="form.get('locales')"></app-locales-select>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.INDUSTRY' | translate }}</label>
          <app-industry-select [parentFormGroup]="form"></app-industry-select>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.RESPONSIBLE_PERSON' | translate }}</label>
          <input type="text" class="form-control" formControlName="responsible_person" />
        </div>
      </div>

      <div class="col-sm-6">
        <app-contact #contactComp [parentFormGroup]="form" [required]="true" [showNote]="true" cols="6"></app-contact>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.CLIENTS_FORM.DESCRIPTION' | translate }}</label>
          <textarea
            class="form-control description-textarea"
            formControlName="description"
            pInputTextarea
            autoResize="true"
          ></textarea>
        </div>
      </div>

      <div class="col-sm-12" *ngIf="form.get('type_id').value !== clientTypeEnum.personal">
        <app-contact-person [parentFormGroup]="form" [withEvent]="true" [showNote]="true" class="d-block mt-3"></app-contact-person>
      </div>

      <div class="col-sm-12">
        <div class="modal-section-title mt-2 mb-2">{{ 'CLIENTS.CLIENTS_FORM.BANK_ACCOUNTS' | translate }}</div>
        <app-bank-data [parentFormGroup]="form"></app-bank-data>
      </div>

      <div class="col-sm-12">
        <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.CLIENT"></app-tags-select>
      </div>

      <div class="col-sm-12">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input type="checkbox" class="custom-control-input" formControlName="active" id="client-form-active" />
          <label class="custom-control-label" for="client-form-active">{{
            'CLIENTS.CLIENTS_FORM.ACTIVE' | translate
          }}</label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="client-form" [disabled]="form.invalid">
    {{ 'CLIENTS.CLIENTS_FORM.SAVE' | translate }}
  </button>
</div>
